import { res } from "@/BaseComponent";
import { apiService } from "@/services/interceptor";

interface GetList {
    page: number;
    size: number;
    searchType?: number | null;
    type?: string;
    startDate?: string;
    endDate?: string;
    searchContent?: string;
}

interface UpdateState {
    idx: number;
    state: number;
}

export interface ResultDetail {
    idx: number;
    wrIdx: number;
    content: string;
    messengerType: number;
    imgPath: string;
    imgName: string;
    imgRealName: string;
    imgExt: string;
    title: string;
    platform: string;
    imgHeight: number;
    imgWidth: number;
    imgSize: number;
    category: string;
    detectionReason: string;
    judgmentReason: string;
    state: number;
    aiState: number;
    meIdx: number;
    createDate: number;
    updateDate: number;
    meName: string;
    file: string;
}

interface SearchResultList {
    data: ResultDetail[];
    draw: number;
    size: number;
    totalPages: number;
    recordsTotal: number;
    recordsFiltered: number;
}

interface GetChartData {
    startDate?: string;
    endDate?: string;
}

export default {
    async getRoomList(param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/room/list", param, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getResultList(idx: number, param: GetList): Promise<res<SearchResultList>> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/list/" + idx, param, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getDetail(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/detail/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async updateState(param: UpdateState): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/update", param, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async remove(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/remove/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },

    async removeForRoom(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/room/remove/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getTypeList(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/code/list/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getGraph(date: GetChartData): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/graph", date, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getResultGraph(date: GetChartData): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/graph/result", date, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async downExcel(param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/watcherBot/room/excel/download", param, { responseType: "blob" });
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async downExcelResult(idx: number, param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post(`/watcherBot/room/result/${idx}/excel/download`, param, { responseType: "blob" });
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
